<template>
  <footer class="scn scn--black py-3">
    <div>
      <img :src="$getImage(`onesti-logo/onesti-logo-branco-${currentLocale}.svg`)" :alt="`${$t('alt.logo')} Onesti`" class="block w-40 mx-auto">
    </div>
    <div class="scn__content container mt-3">
      <div class="footer">
        <div class="footer-col-ctn">
          <div class="footer-col">
            <p class="mb-4">
              {{ $t('footer.paragraph') }}
            </p>
            <div>
              <h4 class="footer-title">
                {{ $t('footer.medias') }}
              </h4>
              <contact-number class="text-grey" />
              <p>ola@onesti.adv.br</p>
              <p>Avenida Paulista, nº 91, 1º andar, 101, Bela Vista</p>
              <p>São Paulo, SP | {{ currentLocale === 'pt' ? 'Brasil' : 'Brazil' }} | 01301-000</p>
            </div>
            <social-media-icons class="mt-2" />
          </div>
          <div class="footer-col my-3 md:mx-4 md:my-0">
            <h4 class="footer-title">
              {{ $t('footer.instagram') }}
            </h4>
            <div v-if="posts.length" class="instagram-grid">
              <a v-for="post in posts"
                 class="instagram-item"
                 target="_blank"
                 :href="post.url"
              >
                <div :style="`background-image: url(${post.image.url})`" class="instagram-item__img" />
              </a>
            </div>
            <h4 class="footer-title mt-4">
              {{ $t('footer.newsletter.title') }}
            </h4>
            <p>
              {{ $t('footer.newsletter.paragraph') }}
            </p>
            <form class="flex items-end" @submit.prevent="subscribeNewsletter">
              <input v-model="newsletterEmail"
                     type="email"
                     class="input w-full mt-2"
                     placeholder="Email"
              >
              <button aria-label="enviar" type="submit" class="btn ml-2">
                <font-awesome-icon icon="share-square" />
              </button>
            </form>
            <span class="flex h-8 items-end">
              <span v-if="newsletterSuccess">Feito!</span>
            </span>
            <onesti-slogan class="mt-3" />
          </div>
          <div class="footer-col">
            <h4 class="footer-title">
              {{ $t('footer.contact.title') }}
            </h4>
            <form class="flex flex-col items-start w-full" action="" @submit.prevent="sendEmail">
              <input v-model="name" type="text" class="input w-full mb-1" :placeholder="$t('footer.contact.placeholder.name')">
              <input v-model="email" type="email" class="input w-full mb-1" :placeholder="$t('footer.contact.placeholder.email')">
              <input v-model="phone" type="tel" class="input w-full mb-1" :placeholder="$t('footer.contact.placeholder.phone')">
              <input v-model="subject" type="text" class="input w-full mb-1" :placeholder="$t('footer.contact.placeholder.subject')">
              <textarea v-model="message" type="text" class="input input--textarea w-full" :placeholder="$t('footer.contact.placeholder.message')" />
              <div class="form-footer-ctn mt-2">
                <button :aria-label="$t('footer.contact.buttonLabel')" class="btn" type="submit">
                  {{ $t('footer.contact.buttonLabel') }}
                </button>
                <div v-if="requiredFieldError || invalidEmailError" class="error-message">
                  <p v-if="requiredFieldError">
                    Preencha todos os campos
                  </p>
                  <p v-else-if="invalidEmailError">
                    Email invalido
                  </p>
                </div>
                <div v-else-if="emailSuccess" class="ml-2">
                  Sua mensagem foi enviada!
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="text-xs mt-3 px-3">
          <p v-for="paragraph in $t('disclaimer')">
            {{ paragraph }}
          </p>
        </div>
      </div>
    </div>
    <footer-links class="mt-3" />
  </footer>
</template>
<script>
import OnestiSlogan from '@/components/onesti-slogan'
import FooterLinks from '@/components/footer-links'
import SocialMediaIcons from '@/components/social-media-icons'
import ContactNumber from '@/components/contact-number'
import api from '@/services/api.ts'

export default {
  name: 'OnestiFooter',
  components: { SocialMediaIcons, OnestiSlogan, FooterLinks, ContactNumber },
  data () {
    return {
      posts: [],
      name: undefined,
      email: undefined,
      phone: undefined,
      subject: undefined,
      message: undefined,
      emailPattern: new RegExp('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}'),
      requiredFieldError: false,
      invalidEmailError: false,
      emailSuccess: false,
      newsletterEmail: undefined,
      newsletterSuccess: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    async sendEmail () {
      if (
        (this.name && this.name !== '') &&
        (this.phone && this.phone !== '') &&
        (this.email && this.email !== '') &&
        (this.subject && this.subject !== '') &&
        (this.message && this.message !== '')
      ) {
        this.requiredFieldError = false
        if (this.emailPattern.test(this.email)) {
          this.invalidEmailError = false
          await api.post('/email/contact', {
            name: this.name,
            phone: this.phone,
            email: this.email,
            subject: this.subject,
            message: this.message
          })
          this.emailSuccess = true
          this.name = this.phone = this.email = this.subject = this.message = ''
        } else this.invalidEmailError = true
      } else this.requiredFieldError = true
    },
    async subscribeNewsletter () {
      if (this.emailPattern.test(this.newsletterEmail)) {
        await api.post('/email/newsletter', {
          email: this.newsletterEmail
        })
        this.newsletterSuccess = true
      }
    }
  },
  async created () {
    try {
      const response = await api.get('/posts?populate=*')
      this.posts = response.data.data
        .filter((_, index) => index < 3)
        .sort((a, b) => b.takenAt - a.takenAt)
    } catch (e) {
      console.log('e', e)
    }
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

$instagram-item: 85px

.footer
  @apply text-sm text-grey

.footer-col-ctn
  @apply flex flex-col
  @screen md
    @apply flex-row

.footer-col
  @apply w-64 mx-auto
  @screen md
    @apply w-1/3

.footer-title
  @apply relative text-sm text-grey-darkest uppercase pl-2 mb-1
  &::after
    @apply no-content absolute pin-l half-t -translate-y-50 bg-pink w-2 h-2

.instagram-grid
  display: grid
  grid-template-columns: $instagram-item $instagram-item $instagram-item
  gap: 0.5rem
  width: 280px
  max-height: 190px

.instagram-item
  @apply relative inline-block
  width: $instagram-item
  height: $instagram-item
  &__overlay
    @apply absolute z-10 inline-flex flex-col justify-center items-center cursor-pointer opacity-0 w-full h-full
    background: rgba(0, 0, 0, 0.6)
    transition: opacity .3s
    &:hover
      @apply opacity-100
  &__img
    background-repeat: no-repeat
    background-size: cover
    width: $instagram-item
    height: $instagram-item

.instagram-count
  @apply text-white text-sm
  span
    @apply mr-1
  &:first-child
    @apply mb-1

.input
  @apply text-white bg-grey p-1
  &--textarea
    @apply h-32
    resize: none

.btn
  @apply text-white bg-pink p-1

.form-footer-ctn
  @apply flex items-center
  @screen md
    @apply flex-col items-start
  @screen lg
    @apply flex flex-row items-center

.error-message
  @apply inline-flex justify-center items-center bg-red text-white whitespace-no-wrap h-8 px-1 ml-2
  @screen md
    @apply ml-0 mt-2
  @screen lg
    @apply ml-2 mt-0
</style>
